import { handleActions } from 'redux-actions';

import { Actions } from '../actions/industries';

const initialState = {
  loading: false,
  error: null,
  value: [],
};

export default handleActions(
  {
    [Actions.INDUSTRIES_REQUEST]: state => ({
      ...state,
      loading: true,
      error: null,
    }),
    [Actions.INDUSTRIES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      error: null,
      value: action.response.result,
    }),
    [Actions.INDUSTRIES_FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
      value: [],
    }),
  },
  initialState
);
